import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as beneficiaryTokenizationActions from 'redux/actions/beneficiaryTokenization';
import * as cardTokenizationActions from 'redux/actions/cardTokenization';
import * as checkoutActions from 'redux/actions/checkout';
import * as globalActions from 'redux/actions/global';
import * as idvActions from 'redux/actions/idv';
import * as issuingActions from 'redux/actions/issuing';
import * as digitalWalletProvidersActions from 'redux/actions/digitalWalletProviders';

export const useActions = () => {
  const dispatch = useDispatch();
  return bindActionCreators(
    {
      ...beneficiaryTokenizationActions,
      ...cardTokenizationActions,
      ...checkoutActions,
      ...globalActions,
      ...idvActions,
      ...issuingActions,
      ...digitalWalletProvidersActions
    },
    dispatch
  );
};
